import { clientLoginCardHtml, bindClientLoginForm } from '../clientLoginCard.js'

export function renderCliente() {
  return clientLoginCardHtml()
}

export function bindCliente(root, ctx) {
  bindClientLoginForm(root, ctx)
}
